import { createContext } from 'react'

export const initialErrorMessage = ''

export const ErrorMessageContext = createContext(initialErrorMessage)
